import { connect } from 'react-redux';
import { 
  fetchCustomers, fetchCustomersPaginate, selectCustomer, resetCurrentCustomer,
  attachDocument, fetchPT, updatePT
} from '../../actions/customers_actions';
import { fetchBaseUsers } from '../../actions/settings_actions';
import Customers from '../../components/Customers/customers';

function mapStateToProps(state) {
  return {
    users: state.settings.all,
    customers: state.customers.all,
    customerTotalPages: state.customers.customerTotalPages,
    customerTotalCount: state.customers.customerTotalCount,
    currentCustomer: state.customers.currentCustomer,
    isLoading: state.customers.isLoading,
    error: state.customers.error,
    userPermissions: state.auth.userPermissions,
    isAttachingDocument: state.customers.isAttachingDocument,
    selectedCompany: state.header.selectedCompany,
    selectedWarehouse: state.header.selectedWarehouse,
  };
}

export default connect(mapStateToProps, {
  fetchCustomers,
  fetchCustomersPaginate,
  selectCustomer,
  resetCurrentCustomer,
  attachDocument,
  fetchPT, 
  updatePT,
  fetchBaseUsers,
})(Customers);



// WEBPACK FOOTER //
// ./master/jsx/containers/Customers/customers.jsx